import { render, staticRenderFns } from "./ServerDistribution.vue?vue&type=template&id=7ba397c6&scoped=true&"
import script from "./ServerDistribution.vue?vue&type=script&lang=js&"
export * from "./ServerDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ServerDistribution.vue?vue&type=style&index=0&id=7ba397c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba397c6",
  null
  
)

export default component.exports